import axios from "axios";
import { Input, Grid, Row, Col } from "react-bootstrap";
import React from "react";
import { t, setLocale } from "../helpers/translate";
import { request } from "../helpers/request";
import { setMicrositeColour } from "../helpers/style";
import LoadingComponent from "./common/LoadingComponent";
import ModalComponent from "./common/ModalComponent";
import ReactGA from "react-ga4";
let config = require("config");

class ClaimUpload extends React.Component {
  constructor(props) {
    setLocale(props.params.lang);
    setMicrositeColour(props.params.microsite);

    sessionStorage.setItem("hide_navbar", true);
    document.body.style.backgroundColor = "white";
    super(props);

    this.state = {
      filesStatus: [],
      claimData: {},
      errors: [],
      submissionId: null,

      showModal: false,
      modalTitle: null,
      modalBody: null,
    };

    this.getAccessToken();

    ReactGA.initialize(
      config.default.microsite_google_analytics_measurement_id
    );
  }

  fireEvent(category, action) {
    const { microsite, lang } = this.props.params;
    const { policyNumber } = this.state;

    const eventObject = {
      hitType: "event",
      eventCategory: category,
      eventAction: action,
      eventLabel: microsite,
      school_name: microsite,
      locale: lang,
    };

    ReactGA.send(eventObject);
  }

  setPolicy(event) {
    this.setState({ policy: event.target.value });
  }

  setDob(value) {
    this.setState({ dob: value });
  }

  getAccessToken() {
    this.setState({ loading: true });
    jQuery
      .ajax({
        url: `${config.default.auth_base_api}/token/travel/basic`,
        method: "POST",
        data: {
          token: config.default.guest_token,
        },
      })
      .always((response, statusText) => {
        this.setState({ loading: false });
        if (statusText == "success") {
          sessionStorage.setItem(
            "auth",
            "Bearer" + " " + response["access_token"]
          );
        } else {
          this.setState({
            hasError: true,
            modalMessage: t("Unable to retreive token"),
            showErrorModal: true,
          });
        }
      });
  }

  // setToken(response) {
  //   sessionStorage.setItem('auth', 'Bearer' + ' ' + response['access_token']);
  // }

  handleFileSelection(event) {
    event.preventDefault();
    let files = event.target.files;
    this.setState({ filesStatus: this.getFilesArray() });
  }

  getFilesArray() {
    const files = [];
    Object.values(this.claimFormInput.files).forEach((file) => {
      const status = { filename: file.name, status: "Pending" };
      files.push(status);
    });

    Object.values(this.claimDocsInput.files).forEach((file) => {
      const status = { filename: file.name, status: "Pending" };
      files.push(status);
    });

    return files;
  }

  handleUploads = (ev) => {
    this.setState({ processing: true, errors: [] });

    const data = { file_names: [], data: this.state.claimData };

    Object.values(this.state.filesStatus).forEach((file) => {
      data.file_names.push(file.filename);
    });

    data.data.claim_form = this.claimFormInput.files[0] && true;
    data.data.document = this.claimDocsInput.files[0] && true;

    request(
      `${config.default.api}/submitClaim`,
      "POST",
      data,
      function (responseData, status) {
        if (status == 200) {
          this.uploadFiles(responseData["presigned_urls"]);
          this.setState({ submissionId: responseData.submission_id });
        } else {
          this.setState({
            errors: responseData.messages.map((message) => message.message),
          });
        }
        this.setState({ processing: false });
        // this.showModal(t('Success'), t('Your claim has been submitted. Please check your email for the claim submission ID'));
      }.bind(this),
      { "Content-Type": "application/json" },
      true
    );
  };

  displayErrors() {
    let errors = this.state.errors;

    if (errors && errors.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <div className="error-list">
            {errors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </div>
        </div>
      );
    }
    return undefined;
  }

  uploadFiles(data) {
    Object.entries([
      ...this.claimFormInput.files,
      ...this.claimDocsInput.files,
    ]).forEach(([key, file]) => {
      this.uploadToS3(file, data[key]);
    });
  }

  uploadToS3(file, signedRequest) {
    const options = {
      headers: {
        "Content-Type": "pdf",
      },
    };

    axios.put(signedRequest, file, options).then((result) => {
      this.markFilesAsUploaded(file);
    });
  }

  markFilesAsUploaded(file) {
    let filesStatus = this.state.filesStatus;
    let foundIndex = filesStatus.findIndex((x) => x.filename === file.name);
    filesStatus[foundIndex].status = "Complete";
    this.setState({ filesStatus: filesStatus }, this.confirmFileUpload());
  }

  confirmFileUpload() {
    const pendingFiles = this.state.filesStatus.filter(
      ({ status }) => status === "Pending"
    ).length;

    if (pendingFiles == 0) {
      request(
        `${config.default.api}/confirmClaim/${this.state.submissionId}`,
        "GET",
        null,
        function (responseData, status) { }.bind(this),
        { "Content-Type": "application/json" },
        true
      );
    }
  }

  updateClaimDetails(value, key) {
    const claimData = this.state.claimData;
    claimData[key] = value.trim();
    claimData["site"] = this.props.params.microsite;
    this.setState({ claimData: claimData });
  }

  showModal(title, body) {
    this.setState({
      showModal: true,
      modalBody: body,
      modalTitle: title,
    });
  }

  handleModalClose() {
    this.setState({ showModal: false }, function () {
      window.location.reload();
    });
  }

  getClaimFormText() {
    const text = t("for a blank claim form or for more detailed instructions.");

    const micrositeUrl = `${config.default.microsite_url}/${this.props.params.microsite}/${this.props.params.lang}/download-claim-form`;

    return (
      <p>
        <a href={micrositeUrl} target="_blank" className="mr-1">
          {t("Click here")}
        </a>
        {text}
      </p>
    );
  }

  render() {
    return (
      <div className="container">
        <h2 className="page-title row div-center">
          {t("Two Ways To Submit a Claim")}
        </h2>

        {this.state.submissionId ? (
          <div className="div-center">
            <p>
              {t(
                "Your claim has been uploaded successfully. Please check your email often, as we might contact you if more information is needed."
              )}
            </p>
            <p>
              {t("Your Submission ID is")} <b>{this.state.submissionId}</b>
            </p>
          </div>
        ) : (
          <div>
            <ol>
              <li className="claims-title">{t("Are you a Student?")}</li>
              <p>
                {t(
                  "Students can use their dedicated Student Portal to submit new claims, manage existing claims and view their claims history. Get access to the portal by registering"
                )}
                <a
                  target="_blank"
                  className="ml-1 mr-1"
                  href={`https://studyinsuredportal.ca/a/register`}
                  onClick={() => {
                    this.fireEvent("claims_page", "navigate_to_student_portal");
                  }}
                >
                  {t("here")}
                </a>
                {t("or if you’ve already registered, click")}
                <a
                  target="_blank"
                  className="ml-1 mr-1"
                  href={`https://studyinsuredportal.ca/a/student`}
                  onClick={() => {
                    this.fireEvent("claims_page", "navigate_to_student_portal");
                  }}
                >
                  {t("here")}.
                </a>
                {t("Need help registering? Click")}
                <a
                  target="_blank"
                  className="ml-1"
                  href={`http://docs.mshtravel.com/docs/Student/Lloyds/StudyInsured/StudentPortal/StudentPortal_How_to_Register_${t("en")}.pdf`}
                >
                  {t("here")}.
                </a>
              </p>
              <p>
                {t("Find step-by-step instructions to submit a claim through the Student Portal by clicking")}
                <a href={`http://docs.mshtravel.com/docs/Microsites/HowToSubmitAClaim_StudentPortal_${t("en")}.pdf`}
                  target="_blank"
                  className="ml-1"
                >
                  {t("here")}.
                </a>
              </p>
              <p>
                {t("IMPORTANT - Before attempting to log in, you must first register for a StudyInsured ™ Student Portal account with your StudyInsured ™ Policy Number, Last Name and Date of Birth.")}
              </p>
              <div className="div-center">
                <button
                  className="btn button-secondary"
                  onClick={() => {
                    this.fireEvent("claims_page", "navigate_to_student_portal");
                    window.open(
                      "https://studyinsuredportal.ca/a/student",
                      "_blank"
                    );
                  }}
                >
                  {t("Student Portal")}
                </button>
              </div>
              <li className="claims-title">
                {t("Submitting On Behalf of a Student?")}
              </li>

              <p>
                {t(
                  "If you’re submitting a claim on behalf of a student, please complete the form below and submit the details manually."
                )}
              </p>
            </ol>
            <div className="section_container">
              {this.displayErrors()}

              <h4 className="div-center page-title--section-title">
                {t("Claimant Information")}
              </h4>

              <div className="input-container">
                <div className="col-xs-12">
                  <div className="col-xs-12 col-sm-6">
                    <Input
                      placeholder={`${t("Policy Number")} eg: MCP999123456`}
                      type="text"
                      onChange={(event) => {
                        this.updateClaimDetails(
                          event.target.value,
                          "policy_number"
                        );
                      }}
                    />
                  </div>
                  <div className="col-xs-12 col-sm-6">
                    <Input
                      placeholder={t("Email")}
                      type="text"
                      onChange={(event) => {
                        this.updateClaimDetails(event.target.value, "email");
                      }}
                    />
                  </div>
                </div>

                <div className="col-xs-12">
                  <div className="col-xs-12 col-sm-6">
                    <Input
                      placeholder={t("First Name")}
                      type="text"
                      onChange={(event) => {
                        this.updateClaimDetails(
                          event.target.value,
                          "first_name"
                        );
                      }}
                    />
                  </div>
                  <div className="col-xs-12 col-sm-6">
                    <Input
                      placeholder={t("Last Name")}
                      type="text"
                      onChange={(event) => {
                        this.updateClaimDetails(
                          event.target.value,
                          "last_name"
                        );
                      }}
                    />
                  </div>
                </div>
              </div>

              <h4 className="div-center page-title--section-title">
                {t("claim form")}
              </h4>

              <div className="input-container">
                <div className="col-xs-12">
                  <div className="col-xs-12 col-sm-12">
                    {this.getClaimFormText()}
                    <input
                      type="file"
                      label="File"
                      onChange={this.handleFileSelection.bind(this)}
                      ref={(ref) => {
                        this.claimFormInput = ref;
                      }}
                    />
                  </div>
                </div>
              </div>

              <h4 className="div-center page-title--section-title">
                {t("supporting documents")}
              </h4>

              <div className="input-container">
                <div className="col-xs-12">
                  <div className="col-xs-12 col-sm-12">
                    <p>{t("Select all files to upload")}</p>
                    <input
                      type="file"
                      label="File"
                      multiple
                      onChange={this.handleFileSelection.bind(this)}
                      ref={(ref) => {
                        this.claimDocsInput = ref;
                      }}
                    />
                  </div>
                </div>
              </div>

              <h4 className="div-center page-title--section-title">
                {t("files to upload")}
              </h4>

              <div className="input-container">
                <div className="col-xs-12">
                  <Grid fluid>
                    {this.state.filesStatus.map((file, index) => {
                      return (
                        <Row>
                          <Col sm={1}>{index + 1}</Col>
                          <Col sm={5}>{file.filename}</Col>
                          <Col sm={6}>{file.status}</Col>
                        </Row>
                      );
                    })}
                  </Grid>
                </div>
              </div>

              <br />
              <div className="div-center">
                <button
                  className="btn button-secondary"
                  onClick={this.handleUploads.bind(this)}
                >
                  {t("submit claim")}
                </button>
              </div>
            </div>
          </div>
        )}

        <LoadingComponent
          show={this.state.processing}
          text={t("Processing Request")}
        />

        <ModalComponent
          title={this.state.modalTitle}
          body={this.state.modalBody}
          onClose={this.handleModalClose.bind(this)}
          show={this.state.showModal}
        />
      </div>
    );
  }
}
ClaimUpload.displayName = "Homepage";
export default ClaimUpload;



// WEBPACK FOOTER //
// ./src/components/ClaimUploadStudent.js